import React from "react";
import Marquee from "react-fast-marquee";
import { COMPANY } from "../data/content";

const items = [
  "Healthcare",
  "Retail",
  "Enterprise",
  "AI-Powered",
  "Cloud Native",
  "Microsoft Dynamics 365",
  "Digital Transformation",
];

const EditorialMarquee = () => {
  return (
    <section className="border-y border-border bg-secondary/40 py-8" data-testid="marquee-section">
      <Marquee speed={38} gradient={false} pauseOnHover>
        {items.concat(items).map((item, i) => (
          <div key={i} className="flex items-center">
            <span className="px-8 font-display text-4xl font-bold tracking-tight text-outline sm:text-6xl">
              {item}
            </span>
            <span className="h-2.5 w-2.5 rounded-full bg-teal" />
          </div>
        ))}
      </Marquee>
    </section>
  );
};

export default EditorialMarquee;
